.summary-bar {
  margin: 20px auto;
}

.container {
  display: flex;
}

.chart-section {
  width: 50%;
  margin: 20px;
}

.new-orders-graph {
  position: relative;
  margin-top: 20px;
}

.open-orders-aging-graph {
  margin-top: 24px;
}
